export enum UpgradeModalActionTypes {
  MODAL_SHOW = "@@upgradeModal/MODAL_SHOW",
  MODAL_HIDE = "@@upgradeModal/MODAL_HIDE",
}

export interface UpgradeModalState {
  modalShow: boolean;
}
